import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { Activity, LogIn, LogOut, Menu, Sprout, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const initialsOf = (profile, user) => {
    const source = profile?.full_name || user?.email || '';
    const parts = source.split(/[\s@.]+/).filter(Boolean);
    return (parts[0]?.[0] || 'U').toUpperCase() + (parts[1]?.[0] || '').toUpperCase();
};

const UserMenu = () => {
    const { configured, loading, user, profile, isAdmin, signOut } = useAuth();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const onClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onClick);
        return () => document.removeEventListener('mousedown', onClick);
    }, []);

    if (!configured || loading) return null;

    if (!user) {
        return (
            <Link to="/login" className="user-menu-signin">
                <LogIn size={16} /> Sign in
            </Link>
        );
    }

    const name = profile?.full_name || user.email;
    const avatar = profile?.avatar_url;

    return (
        <div className="user-menu" ref={ref}>
            <button className="user-menu-trigger" onClick={() => setOpen((value) => !value)} aria-label="Account menu" aria-haspopup="menu" aria-expanded={open}>
                {avatar
                    ? <img src={avatar} alt="" className="user-menu-avatar" />
                    : <span className="user-menu-avatar user-menu-avatar-fallback">{initialsOf(profile, user)}</span>}
            </button>
            {open && (
                <div className="user-menu-popover" role="menu">
                    <div className="user-menu-identity">
                        <span className="user-menu-avatar user-menu-avatar-fallback">{initialsOf(profile, user)}</span>
                        <div>
                            <strong>{name}</strong>
                            <small>{user.email}</small>
                        </div>
                    </div>
                    <Link to="/practice" className="user-menu-item" role="menuitem" onClick={() => setOpen(false)}>
                        <Sprout size={16} /> My Practice
                    </Link>
                    <Link to="/more" className="user-menu-item" role="menuitem" onClick={() => setOpen(false)}>
                        <Menu size={16} /> More tools &amp; resources
                    </Link>
                    <Link to="/settings" className="user-menu-item" role="menuitem" onClick={() => setOpen(false)}>
                        <User size={16} /> Account &amp; settings
                    </Link>
                    {isAdmin && (
                        <Link to="/admin" className="user-menu-item" role="menuitem" onClick={() => setOpen(false)}>
                            <Activity size={16} /> Admin operations
                        </Link>
                    )}
                    <button className="user-menu-item" role="menuitem" onClick={signOut}>
                        <LogOut size={16} /> Sign out
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserMenu;
